import React from 'react';
import { PersonalLoanDetails } from '~/scenes';
import { Stack } from '../stackNavigation';

export const PersonalLoanNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_PersonalLoan"
      component={PersonalLoanDetails}
    />
  </Stack.Group>
);
